import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useAgreementsList() {
    const toast = useToast()
    const records = ref([])

    const client = ref(JSON.parse(localStorage.getItem('userData')).client)

    let columns = []

    // Table Handler
    if(client.value.type !== 2){
        if(client.value.type === 0){
            columns = [
                { key: 'barcode', label: 'Barcode', sortable: true },
                { key: 'luggage', label: 'Luggage Tag', sortable: true },
                // { key: 'mass', label: 'Mass', sortable: true },
                { key: 'agreement', label: 'PCN Number', sortable: false },
                { key: 'owner', label: 'Grower #', sortable: false },
                { key: 'mass', label: 'Weight(KGs)', sortable: false },
                { key: 'govGrade', label: 'TTB Grade', sortable: true },
                { key: 'location', label: 'Location', sortable: true },
                { key: 'capturedBy', label: 'Captured By', sortable: false },
                { key: 'updated_at', label: 'Captured At', sortable: true },
                'actions',
            ]
        }
        else{
            columns = [
                { key: 'barcode', label: 'Barcode', sortable: true },
                { key: 'agreement', label: 'PCN Number', sortable: false },
                { key: 'owner', label: 'Grower #', sortable: false },
                { key: 'mass', label: 'KGs', sortable: false },
                { key: 'govGrade', label: 'N/Grade', sortable: true },
                { key: 'capturedBy', label: 'Captured By', sortable: false },
                { key: 'updated_at', label: 'Captured At', sortable: true },
                'actions',
            ]
        }
    }
    else{
        columns = [
            { key: 'owner', label: 'Society', sortable: true },
            { key: 'barcode', label: 'Barcode', sortable: true },
            { key: 'mass', label: 'KGs', sortable: false },
            { key: 'govGrade', label: 'TTB Grade', sortable: true },
            { key: 'capturedBy', label: 'Captured By', sortable: false },
            { key: 'updated_at', label: 'Captured At', sortable: true },
            // 'actions',
        ]
    }

    const from = ref(0)
    const to = ref(0)
    const meta = ref({ from: 0, to: 0, total: 0 })
    const perPage = ref(10)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [5, 10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('updated_at')
    const isSortDirDesc = ref(true)
    const locationFilter = ref(null)
    const season_id = ref(null)
    const buyer_id = ref(null)
    const market_id = ref(null)
    const sale_id = ref(null)
    const saleTickets = ref([])

    const refetch = () => {
        records.value.refresh()
    }

    watch([season_id, buyer_id, market_id, sale_id, currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
        refetch()
    })

    const fetch = (ctx, callback) => {
        store
            .dispatch('cromis-ticket/list', {
            sale_id: sale_id.value,
            query: searchQuery.value,
            per_page: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response => {
            const { tickets, meta } = response.data

            meta.value = meta
            saleTickets.value = tickets

            callback(tickets)
            totalRecords.value = meta.value.total
            from.value = meta.value.from
            to.value = meta.value.to
        })
        .catch((error) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching tickets list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    // *===============================================---*
    // *--------- UI ---------------------------------------*
    // *===============================================---*

    const resolveGrowerTypeVariant = society => {
        if (society !== null) return 'success'
        return 'primary'
    }

    const resolveStatusVariant = status => {
        if (status === 1) return 'success'
        if (status === 0) return 'secondary'
        return 'warning'
    }

    return {
        fetch,
        columns,
        perPage,
        currentPage,
        totalRecords,
        from,
        to,
        meta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        records,
    
        // resolveUserRoleVariant,
        // resolveUserRoleIcon,
        resolveGrowerTypeVariant,
        resolveStatusVariant,
        refetch,
    
        // Extra Filters
        // roleFilter,
        // planFilter,
        // statusFilter,
        client,
        locationFilter,
        season_id,
        buyer_id,
        market_id,
        sale_id,
        saleTickets,
    }
}
